import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Header from "@/components/layout/Header";
import Footer from "@/components/layout/Footer";
import Home from "@/pages/Home";
import BookJourney from "@/pages/BookJourney";
import HowItWorks from "@/pages/HowItWorks";
import AreasCovered from "@/pages/AreasCovered";
import Drivers from "@/pages/Drivers";
import Faqs from "@/pages/Faqs";
import Contact from "@/pages/Contact";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import JobShare from "@/pages/JobShare";
import DriverTerms from "@/pages/DriverTerms";
import Match from "@/pages/Match";
import GreatDunmowToLondon from "@/pages/routes/GreatDunmowToLondon";
import FelstedFlitchGreenToLondon from "@/pages/routes/FelstedFlitchGreenToLondon";
import BishopsStortfordToLondon from "@/pages/routes/BishopsStortfordToLondon";
import StanstedTakeleyToLondon from "@/pages/routes/StanstedTakeleyToLondon";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <div className="flex min-h-screen flex-col bg-[#050505] text-white">
        <Header />
        <div className="flex-1">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/book" element={<BookJourney />} />
            <Route path="/how-it-works" element={<HowItWorks />} />
            <Route path="/areas-covered" element={<AreasCovered />} />
            <Route path="/great-dunmow-to-london" element={<GreatDunmowToLondon />} />
            <Route path="/felsted-flitch-green-to-london" element={<FelstedFlitchGreenToLondon />} />
            <Route path="/bishops-stortford-to-london" element={<BishopsStortfordToLondon />} />
            <Route path="/stansted-mountfitchet-takeley-to-london" element={<StanstedTakeleyToLondon />} />
            <Route path="/drivers" element={<Drivers />} />
            <Route path="/faqs" element={<Faqs />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy-policy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/job-share" element={<JobShare />} />
            <Route path="/driver-terms" element={<DriverTerms />} />
            <Route path="/match" element={<Match />} />
            <Route path="*" element={<Home />} />
          </Routes>
        </div>
        <Footer />
      </div>
      <Toaster position="bottom-center" />
    </BrowserRouter>
  );
}

export default App;
